import { InputHTMLAttributes, forwardRef } from 'react'
import { SquareCheck, Square, SquareMinus } from 'lucide-react'
import Icon, { IconProps } from './Icon'

export type IndeterminateCheckboxProps = Omit<InputHTMLAttributes<HTMLDivElement>, 'checked'> & {
    indeterminate?: boolean
    checked?: boolean
    size?: string
    color?: IconProps['color']
}

const IndeterminateCheckbox = forwardRef<HTMLDivElement, IndeterminateCheckboxProps>(
    ({ indeterminate = false, className = '', checked = false, size = '3', color = 'secondary', ...rest }, ref) => {
        const renderIcon = () => {
            if (checked) {
                return <Icon icon={SquareCheck} size={size} />
            } else if (indeterminate) {
                return <Icon icon={SquareMinus} size={size} />
            } else {
                return <Icon icon={Square} size={size} color={color} />
            }
        }

        return (
            <div
                ref={ref}
                className={`inline-flex items-center justify-center cursor-pointer ${className}`}
                role="checkbox"
                aria-checked={checked}
                tabIndex={0}
                data-indeterminate={indeterminate}
                {...rest}
            >
                {renderIcon()}
            </div>
        )
    }
)

export default IndeterminateCheckbox
